import { createAction } from '@ngrx/store';

export const loadViewCounts = createAction('[Entity Views] Load View Counts');